import React from 'react';
import { MenuItem, Button, Select } from '@mui/material';
import { Cancel, Start } from '@mui/icons-material';
import Grid from '@mui/material/Grid';

function Logic(props) {
  return (
    <Select
      style={{
        width: '100%',
        backgroundColor: 'var(--mui-palette-action-hover)',
        borderRadius: '4px',
        height: '36px',
        color: 'var(--mui-palette-text-secondary)',
        textAlign: 'center',
      }}
      name="selectType"
      disableUnderline
      variant="standard"
      labelId="demo-simple-select-outlined-label"
      className="dropdown-mat selectStandard"
      value={props.value}
      onChange={event => {
        props.onChange(event.target.value);
      }}
    >
      <MenuItem value={'OR'}> OR </MenuItem>
      <MenuItem value={'AND'}> AND </MenuItem>
    </Select>
  );
}

function OutputType(props) {
  return (
    <Select
      style={{
        width: '100%',
        backgroundColor: 'var(--mui-palette-action-hover)',
        borderRadius: '4px',
        height: '36px',
        color: 'var(--mui-palette-text-secondary)',
      }}
      name="selectType"
      disableUnderline
      variant="standard"
      labelId="demo-simple-select-outlined-label"
      className="dropdown-mat selectStandard"
      displayEmpty
      value={props.value}
      onChange={event => {
        props.onChange(event.target.value);
      }}
    >
      <MenuItem value="" disabled>
        {' '}
        Select type{' '}
      </MenuItem>
      <MenuItem value={'TEXT'}> Text </MenuItem>
      <MenuItem value={'NUMBER'}> Number </MenuItem>
    </Select>
  );
}

function SelectFuc(props) {
  return (
    <React.Fragment>
      <Select
        // native
        style={{
          width: '100%',
          backgroundColor: 'var(--mui-palette-action-hover)',
          borderRadius: '4px',
          height: '36px',
          color: 'var(--mui-palette-text-secondary)',
        }}
        name="selectFunc"
        displayEmpty
        value={props.value}
        onChange={event => {
          props.onChange(event.target.value);
        }}
        disableUnderline
        labelId="demo-simple-select-outlined-label"
        className="dropdown-mat selectStandard"
        variant="standard"
      >
        <MenuItem value="" disabled>
          {' '}
          Function{' '}
        </MenuItem>
        <MenuItem value={'CONTAIN'}> contains </MenuItem>
        <MenuItem value={'NOTCONTAIN'}> does not contain </MenuItem>
        <MenuItem value={'MATCHES'}> matches </MenuItem>
        <MenuItem value={'NOTMATCH'}> does not match </MenuItem>
        <MenuItem value={'EQUAL'}> equals </MenuItem>
        <MenuItem value={'NOTEQUAL'}> does not equal </MenuItem>
        <MenuItem value={'GREATERTHAN'}> greater than </MenuItem>
        <MenuItem value={'GREATERTHANOREQUAL'}> greater than or equal to </MenuItem>
        <MenuItem value={'LESSTHAN'}> less than </MenuItem>
        <MenuItem value={'LESSTHANOREQUAL'}> less than or equal to </MenuItem>
        <MenuItem value={'NOTEMPTY'}> is not empty </MenuItem>
        <MenuItem value={'EMPTY'}> is empty </MenuItem>
      </Select>
    </React.Fragment>
  );
}

function SelectThenValue(props) {
  return (
    <React.Fragment>
      <Select
        // native
        style={{
          width: '100%',
          backgroundColor: 'var(--mui-palette-action-hover)',
          borderRadius: '4px',
          height: '36px',
          color: 'var(--mui-palette-text-secondary)',
        }}
        name="selectFunc"
        displayEmpty
        value={props.value}
        onChange={event => {
          props.onChange(event.target.value);
        }}
        disableUnderline
        labelId="demo-simple-select-outlined-label"
        className="dropdown-mat selectStandard"
        variant="standard"
      >
        <MenuItem value="" disabled>
          {' '}
          Select workflow{' '}
        </MenuItem>
        <MenuItem value={'CONTINUE'}>
          {' '}
          <Grid container direction={'row'} alignItems={'center'} columnGap={2}>
            {' '}
            <Start /> Continue the workflow{' '}
          </Grid>{' '}
        </MenuItem>
        <MenuItem value={'STOP'}>
          {' '}
          <Grid container direction={'row'} alignItems={'center'} columnGap={2}>
            {' '}
            <Cancel /> Do not continue the workflow{' '}
          </Grid>{' '}
        </MenuItem>
      </Select>
    </React.Fragment>
  );
}

export { Logic, SelectFuc, OutputType, SelectThenValue };
